export function decodeHtmlEntities(value) {
  if (typeof document === 'undefined') {
    return value;
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
}

export function parseReactProps(rawProps) {
  if (typeof rawProps !== 'string') {
    return rawProps || {};
  }

  try {
    return JSON.parse(rawProps);
  } catch (initialError) {
    const decodedProps = decodeHtmlEntities(rawProps);

    if (decodedProps !== rawProps) {
      return JSON.parse(decodedProps);
    }

    throw initialError;
  }
}
